import { render, staticRenderFns } from "./RepresentativeFileModal.vue?vue&type=template&id=4489c01c"
import script from "./RepresentativeFileModal.vue?vue&type=script&lang=js"
export * from "./RepresentativeFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports